import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import {
  Button,
  FlagIcon,
  LocalModal,
  ModalContentContainer,
} from '@/components';
import { getSortedRegions, RegionSwitchMenuContents } from '@/containers';
import { useRegionPreferenceManagement } from '@/hooks';
import { EVENT_CONSTANTS } from '@/services';

export const AccountPreferences = () => {
  const [
    isContentRegionPreferencesModalOpen,
    setIsContentRegionPreferencesModalOpen,
  ] = useState(false);

  const { regionOptions, selectedRegions } = useRegionPreferenceManagement();

  return (
    <Box>
      <Typography variant="h3" sx={{ mb: 1.5 }}>
        Account Preferences
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box sx={styles.container}>
          <Box sx={{ maxWidth: '80%', mt: 1 }}>
            <Typography variant="body2SemiBold">Episode Regions</Typography>
            <Typography variant="body2" sx={{ mt: 1, color: 'text.light' }}>
              Your library and recommendations are personalized to these
              regions.
            </Typography>
            <Box
              sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
              {getSortedRegions(selectedRegions ?? []).map(selectedRegion => (
                <Box
                  key={selectedRegion}
                  sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <FlagIcon region={selectedRegion} width={22} />
                  <Typography variant="body3">
                    {regionOptions?.find(r => r.slug === selectedRegion)?.value}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
          <Button
            variant="secondary"
            label="Edit"
            fullWidth={false}
            sx={styles.button}
            onClick={() => {
              setIsContentRegionPreferencesModalOpen(true);
            }}
          />
        </Box>
      </Box>
      <LocalModal
        open={isContentRegionPreferencesModalOpen}
        onClose={() => setIsContentRegionPreferencesModalOpen(false)}
        name={'Content Region Preferences'}>
        <ModalContentContainer>
          <Typography variant="h1">Episode Region Preferences</Typography>
          <Typography variant="body3" color="text.main" sx={{ mt: 1, mb: 3 }}>
            Your library and recommendations will focus on episodes from your
            selected regions. You can still find all episodes through search.
          </Typography>
          <RegionSwitchMenuContents
            onClose={() => setIsContentRegionPreferencesModalOpen(false)}
            location={{
              component: EVENT_CONSTANTS.COMPONENT.PROFILE_PAGE_FORM,
            }}
          />
        </ModalContentContainer>
      </LocalModal>
    </Box>
  );
};

const styles = {
  container: {
    borderTop: '1px solid #00000010',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    wordWrap: 'break-word',
  },
  button: {
    mt: 1,
    width: 50,
  },
};
